import { useMsal } from "@azure/msal-react";
import { getActiveAccount, getUser } from "../api/auth";
import { User } from "../models/User";
import { createContext, useEffect, useMemo, useState } from "react";
import { loadRecord } from "../api/connection";
import { Org } from "../models/Org";
import { getWsInstance } from "../api/WsManagement";
import { runningOnRobot } from "../api/host-aware";
import { debug } from "console";

export const PageContext = createContext({
  user: undefined as User | undefined,
  setUser: (user: User) => { },
  isLoggedIn: false,
  org: undefined as Org | undefined,
  setOrg: (org: Org) => { },
});

let _user: User | undefined;
let _org: Org | undefined;

export function getCreds() {
  if (!_user) {
    throw new Error("User not found");
  }
  if (!_org) {
    throw new Error("Org not found for user " + _user._id);
  }
  return {
    user: _user!,
    org: _org!,
  };
}

export function setCreds(user: User, org: Org) {
  _user = user;
  _org = org;
}

export const PageProvider = (props: any) => {
  const [org, setOrg] = useState<Org>();
  const [user, setUser] = useState<User>();
  // const { instance } = useMsal();
  const isLoggedIn = runningOnRobot() ? true : (getActiveAccount(false) !== null);

  useEffect(() => {
    const getUserData = async () => {
      const u = runningOnRobot() ? _user : (await getUser());
      const wsManagement = getWsInstance();
      wsManagement.uiService.user = u!;
      _user = u;
      // debugger
      if (u && u.orgId) {
        const o1 = runningOnRobot() ?
        _org :
        (await loadRecord<Org>("organizations", u.orgId));
        wsManagement.uiService.org = o1!;
        _org = o1;
        if (o1) {
          setOrg(o1);
        }
      }
      setUser(u);
    };

    if (isLoggedIn) {
      getUserData();
    }
    //}, [isLoggedIn, instance]);
  }, [isLoggedIn]);

  const contextValue = useMemo(
    () => ({
      user,
      setUser,
      isLoggedIn,
      org,
      setOrg,
    }),
    [user, isLoggedIn, org]
  );

  return (
    <PageContext.Provider value={contextValue}>
      {props.children}
    </PageContext.Provider>
  );
};
